<ts-dialog title="Add New Record" (closeDialog)="close()">
  <main ts-dialog-body class="flex flex-col flex-1 w-full">
    @if (!isNewRecord()) {
      <form [formGroup]="addLinkToCOValueForm">
        <section class="flex flex-col flex-1">
          @if (customObject) {
            @if (customObjectSearchFieldLabel) {
              <app-alert-banner class="mb-4">
                <p>
                  Search results are based on the search field
                  <strong>{{ customObjectSearchFieldLabel }}</strong>
                  set in the <strong>{{ customObject.label }}</strong> Custom Object's configuration page.
                </p>
              </app-alert-banner>
            } @else {
              <app-alert-banner [type]="'warning'" class="mb-4">
                <p>
                  <strong>{{ customObject.label }}</strong> object does not have the search field configured.<br />Please
                  go to the settings <a>page</a> and choose a field in the configuration tab.
                </p>
              </app-alert-banner>
            }
          }
          <mat-form-field>
            <mat-label>{{ customObjectType }}</mat-label>
            <input
              matInput
              [formControlName]="'name'"
              [matAutocomplete]="matAutocompleteCOValue"
              [spellcheck]="false"
            />
          </mat-form-field>
          <mat-autocomplete
            #matAutocompleteCOValue="matAutocomplete"
            [disableRipple]="true"
            (optionSelected)="autocompleteSelected($event)"
          >
            @for (option of customObjectOptions; track option.id) {
              <mat-option [value]="option.name" [id]="option.id">
                {{ option.name }}
              </mat-option>
            }
            @if (noResultsFound) {
              <mat-option disabled>No results found!</mat-option>
              @if (canAddNewRecord() && customObject) {
                <mat-option
                  disabled
                  (click)="addNew()"
                  [appAuthorize]="getCreateCustomObjectPermission(customObject.name)"
                  denyAction="hide"
                >
                  <span class="add-new-option">Create a New Record</span>
                </mat-option>
              }
            }
          </mat-autocomplete>
        </section>
      </form>
    } @else {
      <form [formGroup]="createLinkToCOValueForm">
        <section class="flex flex-col flex-1">
          <p class="mb-4">Please select one of the available saved views to use the fields from:</p>

          <mat-form-field class="w-full">
            <mat-label>Select a saved view</mat-label>
            <mat-select [formControlName]="'saved_view_id'" (selectionChange)="onSavedViewChange($event)">
              @for (savedView of savedViews(); track savedView.id) {
                <mat-option [value]="savedView.id">
                  {{ savedView.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (fieldsFromSavedView().length > 0) {
            <mat-divider class="my-2"></mat-divider>
            <section class="fields-wrapper">
              <mat-form-field class="w-full gt-xs:pr-3">
                <mat-label>{{ customObject.label }} Layout</mat-label>
                <mat-select [formControlName]="'template_id'">
                  @for (template of templates(); track template.id) {
                    <mat-option [value]="template.id">
                      {{ template.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @for (field of fieldsFromSavedView(); track field.name) {
                <app-form-field
                  [fieldDef]="field.fieldDef"
                  [model]="formValues()"
                  [data]="data"
                  [readonly]="field.fieldDef?.meta?.readonly ?? false"
                  [alwaysHideHistory]="true"
                  (onUpdate)="onFieldUpdate($event)"
                ></app-form-field>
              }
            </section>
          }
        </section>
      </form>
    }
  </main>
  <footer ts-dialog-actions class="ts-dialog-actions-container">
    <ts-button variant="secondary" (buttonClick)="close()">Cancel</ts-button>
    <ts-button variant="primary" [disabled]="isSaveButtonDisabled" (buttonClick)="saveAndClose()">Save</ts-button>
  </footer>
</ts-dialog>
